const EVENT_ID_PARAM = 'eventId';
const EXTERNAL_EVENT_ID_PARAM = 'externalEventId';
const EXTERNAL_COMPETITION_PARAM = 'competition';
const COMPETITION_NAME_PARAM = 'competitionName';
const QUERY_PREFIX = '?';
const EMPTY_VALUE = '';

export const readChallengePrefillSearch = (search) => {
  const params = new URLSearchParams(search || EMPTY_VALUE);
  return {
    eventId: normalizeParam(params.get(EVENT_ID_PARAM)),
    externalEventId: normalizeParam(params.get(EXTERNAL_EVENT_ID_PARAM)),
    competition: normalizeParam(params.get(EXTERNAL_COMPETITION_PARAM)),
    competitionName: normalizeParam(params.get(COMPETITION_NAME_PARAM)),
  };
};

export const hasChallengePrefill = (prefill = {}) => Boolean(prefill.eventId || prefill.externalEventId);

export const buildChallengePrefillSearch = (prefill = {}) => {
  const params = new URLSearchParams();
  appendParam(params, EVENT_ID_PARAM, prefill.eventId);
  appendParam(params, EXTERNAL_EVENT_ID_PARAM, prefill.externalEventId);
  appendParam(params, EXTERNAL_COMPETITION_PARAM, prefill.competition);
  appendParam(params, COMPETITION_NAME_PARAM, prefill.competitionName);
  const query = params.toString();
  return query ? `${QUERY_PREFIX}${query}` : EMPTY_VALUE;
};

export const appendChallengePrefillSearch = (path, prefill = {}) => {
  const search = buildChallengePrefillSearch(prefill);
  if (!search) return path;
  return `${path}${search}`;
};

export const buildRoomSelectionPathForEvent = (eventId) => (
  appendChallengePrefillSearch('/rooms', { eventId })
);

export const buildRoomSelectionPathForExternalEvent = (externalEventId, competition, competitionName) => (
  appendChallengePrefillSearch('/rooms', { externalEventId, competition, competitionName })
);

// ===================================================================================================================
// = Implementation
// ===================================================================================================================

const appendParam = (params, name, value) => {
  const normalized = normalizeParam(value);
  if (normalized) params.set(name, normalized);
};

const normalizeParam = (value) => String(value || EMPTY_VALUE).trim();
